import { AdvancingApproveApp } from "advancingapprove/App";
import { AdvancingProvideApp } from "advancingprovide/App";
import InvitationApp from "Invitation/App";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const advancingRoute: RouteObject = {
  path: "advancing",
  children: [{
    path: "invitation/:secret",
    loader: () => viewModel,
    Component: InvitationApp,
  }, {
    path: "invitation/:secret/provide",
    loader: () => viewModel,
    Component: AdvancingProvideApp,
  }, {
    path: ":key/approve",
    loader: () => viewModel,
    Component: AdvancingApproveApp,
  }]
};
